export const name = "NET.IP_NET_MASK";
export const summary = `Gets a network mask.`;
export const reference = `
## NET.IP_NET_MASK

Gets a network mask.

\`\`\`
NET.IP_NET_MASK(num_output_bytes, prefix_length)
\`\`\`

### Description

Returns a network mask: a byte sequence with length equal to \`num_output_bytes\`, where the first \`prefix_length\` bits are set to 1 and the other bits are set to 0. \`num_output_bytes\` and \`prefix_length\` are INT64. This function throws an error if \`num_output_bytes\` isn't 4 (for IPv4) or 16 (for IPv6). It also throws an error if \`prefix_length\` is negative or greater than \`8 * num_output_bytes\`.


### Return Data Type

BYTES


### Example



\`\`\`
SELECT x, y, FORMAT("%T", NET.IP_NET_MASK(x, y)) AS ip_net_mask
FROM UNNEST([
  STRUCT(4 as x, 0 as y),
  (4, 20),
  (4, 32),
  (16, 0),
  (16, 1),
  (16, 128)
]);

/*--------------------------------------------------------------------------------*
 | x | y | ip_net_mask |
 +--------------------------------------------------------------------------------+
 | 4 | 0 | b"\\x00\\x00\\x00\\x00" |
 | 4 | 20 | b"\\xff\\xff\\xf0\\x00" |
 | 4 | 32 | b"\\xff\\xff\\xff\\xff" |
 | 16 | 0 | b"\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00" |
 | 16 | 1 | b"\\x80\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00" |
 | 16 | 128 | b"\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff\\xff" |
 *--------------------------------------------------------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/net_functions
`;
